<div
  class="form-area"
>
  <div>
    <a href="https://motion.cloud">
      <img
        class="logo"
        src="../../../assets/img/motion-R.png"
      >
    </a>
    @if (!totpEntryMode) {
      <div>
        <h4>
          Motion Platform <span style="text-transform: none">v2</span>
        </h4>
      </div>
    }
    @if (totpEntryMode) {
      <div>
        <h4>Two-Factor Authentication</h4>
        <p>Enter your 2FA code to continue</p>
      </div>
    }
  </div>

  <div>
    <form
      role="form"
      [ngClass]="{'hide': totpEntryMode}"
    >
      <div>
        <input
          type="text"
          name="username"
          placeholder="Username"
          aria-label="Username"
          [(ngModel)]="enteredUsername"
          (keyup.enter)="attemptLogin($event)"
          (ngModelChange)="resetInvalidState()"
        >
      </div>

      <div>
        <input
          type="password"
          name="password"
          placeholder="Password"
          aria-label="Password"
          [(ngModel)]="enteredPassword"
          (keyup.enter)="attemptLogin($event)"
          (ngModelChange)="resetInvalidState()"
        >
      </div>

      <!--      <label class="toggle">-->
      <!--        <input type="checkbox">-->
      <!--        <span class="slider"></span>-->
      <!--      </label>-->

      <div class="bottom">
        @if (!loginBadAttempt) {
          <button
            type="button"
            [ngClass]="{'loading': loginAttempting}"
            (click)="attemptLogin($event)"
          >
            <span>Log In</span>
            <motn-spinner></motn-spinner>
          </button>
        }

        @if (loginBadAttempt) {
          <button
            type="button"
            [ngClass]="{'red': 1, 'loading': loginAttempting}"
            (click)="attemptLogin($event)"
          >
            <span>Try Again</span>
            <motn-spinner></motn-spinner>
          </button>
        }

        @if (isWeb) {
          <div class="app-stores">
            <a
              href="https://apps.apple.com/us/app/motion-for-ios/id1546751128"
              target="_blank"
            >
              <i class="fa-brands fa-app-store-ios"></i>
            </a>

            <a
              href="https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=cloud.motion.app&ddl=1&pcampaignid=web_ddl_1"
              target="_blank"
            >
              <i class="fa-brands fa-google-play"></i>
            </a>
          </div>
        }
      </div>
    </form>

    <form
      role="form"
      [ngClass]="{'hide': !totpEntryMode}"
    >
      <div>
        <input
          type="tel"
          name="totp"
          placeholder="2FA Code"
          aria-label="2FA Code"
          [(ngModel)]="enteredTotpCode"
          (keyup.enter)="attemptTotpValidation($event)"
          (ngModelChange)="resetInvalidState()"
        >
      </div>

      <div>
        @if (!totpBadAttempt) {
          <button
            type="button"
            [ngClass]="{'green': 1, 'loading': totpAttempting}"
            (click)="attemptTotpValidation($event)"
          >
            <span>Validate</span>
            <motn-spinner></motn-spinner>
          </button>
        }

        @if (totpBadAttempt) {
          <button
            type="button"
            [ngClass]="{'red': 1, 'loading': totpAttempting}"
            (click)="attemptTotpValidation($event)"
          >
            <span>Try again</span>
            <motn-spinner></motn-spinner>
          </button>
        }
      </div>
    </form>
  </div>

  <motn-login-help-buttons></motn-login-help-buttons>

  <div
    class="footer"
  >
    <div class="bold">
      Learn more about Motion&reg; at <a href="https://motion.cloud">motion.cloud</a>
    </div>

    <div>
      By logging in, you accept the terms of our <a
      target="_blank"
      href="https://motion.cloud/eula"
    >EULA</a>
    </div>
  </div>
</div>

<div
  class="splash-area"
  style="background-image: url('../../../assets/img/downtown-cleveland-ohio-usa.jpg')"
>
  <div class="mask"></div>
</div>
